// A card class by its card's name, from a module of card classes (e.g. Constants/Actions/Actions.js). Each class is
// made once, the first time one is looked up, to read the name it gives its card; so a new card only has to be added
// to its module to be found. Classes take what they need of (age, version) and ignore the rest.
const ByName = (classes) => {
    let byName = null;
    return (name) => {
        byName ??= new Map(Object.values(classes).map(Class => [new Class().name, Class]));
        return byName.get(name);
    };
};

module.exports = ByName;
